import { render } from "./SchemaFieldsEditor.vue?vue&type=template&id=6ada5844&scoped=true"
import script from "./SchemaFieldsEditor.vue?vue&type=script&lang=ts"
export * from "./SchemaFieldsEditor.vue?vue&type=script&lang=ts"

import "./SchemaFieldsEditor.vue?vue&type=style&index=0&id=6ada5844&lang=scss"
import "./SchemaFieldsEditor.vue?vue&type=style&index=1&id=6ada5844&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ada5844"

export default script